<p class="text-center text-xl font-bold">Oops, session expired!</p>
<p class="text-center mt-2">Your session has timed out.</p>
